// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","otherNews":"_3KDGl","label":"b5JsP"};